export class BuilderRegistration {
    ParentCompanyName: string;
    companyName: string;
    phoneNumber: string;
    phoneNumberExtension: string;
    email: string;
    adminFirstName: string;
    adminMiddleName: string;
    adminLastName: string;
    adminPhoneNumber: string;
    adminPhoneNumberExtension: string;
    adminEmailAddress: string;
    isPOBox: boolean;
    poBoxNumber: string;
    StreetNumber: string;
    unitNumber: string;
    directionPrefix = [] ;
    streetName: string;
    streetType = [];
    directionSuffix = [];
    address2: string;
    city = [];
    state = [];
    datePicker: Date;
    zipCode: string;
}
